module.exports = __webpack_public_path__ + "icon_clock_50gray.cdf28.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/icon_clock_50gray.svg
// module id = ./src/_asset/sources/assets/images/@svg/icon_clock_50gray.svg
// module chunks = main